import { Texto, Vertical } from '@gravitate-js/excalibrr'
import React from 'react'

type DropdownSelectElementProps = {
  title: string
  description: string
}

export function DropdownSelectElement({ title, description }: DropdownSelectElementProps) {
  return (
    <Vertical className='border-bottom'>
      <Texto weight='bold'>{title}</Texto>
      <Texto style={{ whiteSpace: 'normal' }} category='label'>
        {description}
      </Texto>
    </Vertical>
  )
}
